var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124,
    height: 134,
    fill: "none",
    viewBox: "0 0 124 134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#13247A",
    d: "M122.654 112.532l-36.406 20.699c-1.629.926-4.089 1.035-5.497.222L.951 88.098c-1.41-.802-1.23-2.2.393-3.105l36.411-20.698c1.624-.926 4.084-1.035 5.492-.222l79.801 45.334c1.408.828 1.235 2.199-.394 3.125z",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M124 99.038l-7.5-1.288-73.252-41.627c-1.408-.797-3.868-.698-5.492.227L3.821 75.64 0 74.985v3.823c.032.591.397 1.117.946 1.36l79.8 45.352c1.41.801 3.869.698 5.498-.223l36.405-20.692c.904-.517 1.362-1.174 1.346-1.795l.005-3.771z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear)",
    d: "M122.654 100.621l-36.406 20.698c-1.629.926-4.089 1.035-5.497.228l-79.8-45.36c-1.41-.802-1.23-2.2.393-3.105l36.411-20.698c1.624-.926 4.084-1.035 5.492-.223l79.801 45.36c1.408.776 1.235 2.174-.394 3.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0067B8",
    d: "M122.992 97.233l-42.493 23.863-79.49-44.625 42.493-23.864 79.49 44.626z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0063AD",
    d: "M25.004 62.134l-5.8 3.26c-.262.144-.58.156-.852.031l-.06-.031c-.216-.122-.19-.339.066-.476l5.789-3.265c.261-.138.574-.15.846-.031l.06.031c.233.122.179.339-.05.481z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.09 77.128l-.6.294-1.417-.698.595-.294 1.421.698zM13.106 76.138l-.599.292-1.418-.698.599-.295 1.418.7zM14.114 75.142l-.6.295-1.416-.698.6-.295 1.416.698z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.122 75.141l-.598.296-1.418-.697.598-.296 1.418.697zM39.821 5.956c1.392 0 2.52 1.11 2.52 2.481 0 1.37-1.128 2.482-2.52 2.482-1.392 0-2.52-1.111-2.52-2.482 0-.658.265-1.29.738-1.755.473-.465 1.114-.726 1.782-.726z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#7BDAFF",
    d: "M31.75 5.956c1.02-.003 1.941.6 2.333 1.528.392.927.178 1.995-.543 2.706-.72.71-1.805.924-2.747.54s-1.557-1.289-1.557-2.293c0-1.368 1.125-2.479 2.515-2.481z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#7BDAFF",
    d: "M23.691 5.956c1.392 0 2.52 1.11 2.52 2.481 0 1.37-1.128 2.482-2.52 2.482-1.392 0-2.52-1.111-2.52-2.482 0-1.37 1.128-2.481 2.52-2.481z",
    opacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#7BDAFF",
    d: "M15.626 5.956c1.02 0 1.938.604 2.328 1.531.39.928.175 1.995-.546 2.705-.72.71-1.805.922-2.747.538-.941-.385-1.556-1.29-1.556-2.293 0-1.37 1.129-2.481 2.52-2.481z",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#041860",
    d: "M53.43 89.333c7.796 0 14.114-3.555 14.114-7.94 0-4.386-6.318-7.941-14.113-7.941s-14.114 3.555-14.114 7.94c0 4.386 6.319 7.941 14.114 7.941z",
    opacity: 0.6
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M53.434 94.296c-5.67 0-11.332-1.2-15.645-3.599-4.238-2.343-6.537-5.472-6.537-8.81 0-3.34 2.32-6.448 6.537-8.807 8.625-4.798 22.659-4.798 31.283 0 4.239 2.344 6.538 5.473 6.538 8.806 0 3.334-2.32 6.468-6.532 8.811-4.318 2.4-9.981 3.6-15.645 3.6zm0-24.457c-5.6 0-11.195 1.19-15.454 3.573-4.095 2.277-6.357 5.294-6.357 8.49 0 3.195 2.251 6.217 6.357 8.494 8.519 4.737 22.383 4.737 30.907 0 4.09-2.277 6.357-5.294 6.357-8.494 0-3.201-2.251-6.213-6.357-8.49-4.265-2.384-9.86-3.589-15.453-3.589v.016zM111.029 34.683L50.543.22c-.363-.253-.837-.29-1.236-.098L48.39.64l.414.057c-.116.297-.173.613-.168.93v41.127c0 1.375.844 2.967 1.886 3.557l60.486 34.467c.107.058.219.107.335.145v.47l.901-.516c.475-.35.725-.924.655-1.505V38.255c.015-1.385-.828-2.978-1.87-3.572z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear)",
    d: "M110.009 81.17L49.276 46.964c-1.052-.59-1.894-2.17-1.894-3.53V2.61c0-1.36.847-1.986 1.894-1.396l60.733 34.207c1.052.59 1.894 2.17 1.894 3.53v40.823c0 1.36-.847 1.986-1.894 1.395z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M91.74 37.608v-5.845l1.3.715c.229.123.445.266.645.427.186.153.351.325.493.515.145.194.253.41.32.638.076.25.113.51.109.772 0 .72-.266.982-.786.782.3.223.542.51.704.838.164.356.245.74.239 1.127 0 .556-.125.906-.38 1.055-.254.15-.628.087-1.116-.18l-1.528-.844zm.97-2.927l.303.164c.282.154.477.196.586.124.108-.078.162-.273.162-.592.001-.144-.017-.288-.054-.427-.036-.12-.097-.232-.179-.33-.08-.095-.174-.182-.276-.257-.131-.089-.267-.171-.407-.247l-.135-.072v1.637zm0 2.706l.358.195c.285.158.486.194.601.108.109-.087.163-.298.163-.638.013-.3-.05-.597-.185-.87-.146-.249-.367-.453-.634-.586l-.303-.164v1.955zM94.764 38.967l1.03-5.219.964.553 1.03 6.395-.86-.511-.206-1.464-.876-.511-.206 1.233-.876-.476zm1.19-1.366l.68.389-.34-2.559-.34 2.17zM98.193 40.798v-5.511l.726.344 1.424 3.797v-3.122l.874.418v5.51l-.691-.334-1.459-3.957v3.282l-.874-.427zM101.821 42.903v-6.177l.962.544v2.683l1.042-2.073.913.544-1.01 2.177 1.118 4.066-.962-.544-.908-3.44-.193.288v2.51l-.962-.578zM63.512 46.652l-11.09-6.449v-1.492l11.09 6.448v1.493zM77.626 54.593l-11.09-6.448v-1.493l11.09 6.447v1.494zM91.74 62.533l-11.09-6.448v-1.492l11.09 6.448v1.492zM106.862 70.474l-11.09-6.447v-1.494l11.09 6.448v1.493z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#041860",
    d: "M60.923 16.966l-13.54-1.085v27.29c0 1.362.838 2.946 1.874 3.537l26.04 14.833c6.723-9.409 5.207-23.825 5.207-23.825l-19.581-20.75z",
    opacity: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear)",
    d: "M76.466 40.41L56.454 19.428l-20.013-1.56s-3.194 26.516 20.013 54.592c23.228-1.923 20.012-32.048 20.012-32.048z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear)",
    d: "M36.705 18.86l-4.445 2.446 19.75 1.524 4.445-2.447-19.75-1.524z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_linear)",
    d: "M71.426 43.414l-20.013-20.99-8.23-.81-11.782-.77s-3.195 26.517 20.012 54.593c23.229-1.903 20.013-32.023 20.013-32.023z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M71.633 43.322L51.947 22.69 32.26 21.156l.555-.312 19.938 1.554L72.44 43.026s2.619 24.752-14.37 30.426c16.12-6.185 13.563-30.13 13.563-30.13z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M69.425 43.924L51.415 25.23l-7.402-.722-10.609-.685s-2.893 23.6 18.01 48.637c20.904-1.7 18.01-28.535 18.01-28.535z",
    opacity: 0.2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38.138 29.974l.7.685-.7.686-.7-.686.7-.685zM40.669 29.964l.7.685-.7.685-.7-.685.7-.685zM39.405 28.733l.7.685-.7.685-.7-.685.7-.685zM39.401 31.206l.7.685-.7.685-.7-.685.7-.685zM111.258 26.8l-1.372-1.46 3.301-3.503-3.301-3.502 1.372-1.461 4.677 4.963-4.677 4.963zm-.824-1.46l.824.879 4.129-4.382-4.129-4.382-.824.88 3.301 3.502-3.301 3.502z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#7BDAFF",
    d: "M106.05 17.867l-1.204 1.116 3.629 3.35-3.629 3.35 1.204 1.117 3.635-3.35 1.209-1.117-4.844-4.466z",
    opacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 8.419,
    x2: 97.769,
    y1: 81.563,
    y2: 129.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A9BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#3A9BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#3A9BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3999D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3592CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#2F86C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#2676BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2573BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 10.639,
    x2: 108.537,
    y1: 89.694,
    y2: 68.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59BDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BDAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 113.551,
    x2: 35.226,
    y1: 78.053,
    y2: 19.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59BDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BDAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 52.399,
    x2: 90.406,
    y1: 39.403,
    y2: 78.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2573BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#0364AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 56.455,
    x2: 32.266,
    y1: 20.845,
    y2: 20.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0063AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2573BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 39.711,
    x2: 65.62,
    y1: 36.886,
    y2: 51.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59BDEF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.dd861bf859e337e8f3f5625920990491.svg";
export { ForwardRef as ReactComponent };